import { render } from "./infosCardServicos.vue?vue&type=template&id=2450cfff&scoped=true"
import script from "./infosCardServicos.vue?vue&type=script&lang=js"
export * from "./infosCardServicos.vue?vue&type=script&lang=js"

import "./infosCardServicos.vue?vue&type=style&index=0&id=2450cfff&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2450cfff"]])

export default __exports__